// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import EditableTableController from "./editable_table_controller"
application.register("editable-table", EditableTableController)

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import ConditionalFieldsController from "./conditional_fields_controller"
application.register("conditional-fields", ConditionalFieldsController)

import ConditionalGroupsController from "./conditional_groups_controller"
application.register("conditional-groups", ConditionalGroupsController)

import CommunicationController from "./communication_controller"
application.register("communication", CommunicationController)

import MobilePanelsController from "./mobile_panels_controller"
application.register("mobile-panels", MobilePanelsController)

import FrameLoaderController from "./frame_loader_controller"
application.register("frame-loader", FrameLoaderController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import StreamScriptController from "./stream_script_controller"
application.register("stream-script", StreamScriptController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import ToggleTranslationController from "./toggle_translation_controller"
application.register("toggle-translation", ToggleTranslationController)

import EmailFormController from "./email_form_controller"
application.register("email-form", EmailFormController)

import TinymceController from "./tinymce_controller"
application.register("tinymce", TinymceController)

import AttachmentEditorController from "./attachment_editor_controller"
application.register("attachment-editor", AttachmentEditorController)

import AiDocumentBuilderLauncherController from "./ai_document_builder_launcher_controller"
application.register("ai-document-builder-launcher", AiDocumentBuilderLauncherController)

import ToggleFieldController from "./toggle_field_controller"
application.register("toggle-field", ToggleFieldController)

import FlashStackController from "./flash_stack_controller"
application.register("flash-stack", FlashStackController)

import CrudFormController from "./crud/form_controller"
application.register("crud-form", CrudFormController)

import InfiniteListController from "./infinite_list_controller"
application.register("infinite-list", InfiniteListController)

import DependentMultiSelectController from "./dependent_multi_select_controller"
application.register("dependent-multi-select", DependentMultiSelectController)

import CrudAttachmentsController from "./crud/attachments_controller"
application.register("crud-attachments", CrudAttachmentsController)

import CrudConfirmController from "./crud/confirm_controller"
application.register("crud-confirm", CrudConfirmController)

import A11yDialogController from "./a11y_dialog_controller"
application.register("a11y-dialog", A11yDialogController)

import InlineConfirmController from "./inline_confirm_controller"
application.register("inline-confirm", InlineConfirmController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ReadMoreController from "./read_more_controller"
application.register("read-more", ReadMoreController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import ExpansiveSearchController from "./expansive_search_controller"
application.register("expansive-search", ExpansiveSearchController)

import FormCompletionController from "./form_completion_controller"
application.register("form-completion", FormCompletionController)

import ConfirmationDialogController from "./confirmation_dialog_controller"
application.register("confirmation-dialog", ConfirmationDialogController)

import ModalManagerController from "./modal_manager_controller"
application.register("modal-manager", ModalManagerController)

import SortFilterController from "./sort_filter_controller"
application.register("sort-filter", SortFilterController)

import FilterDropdownController from "./filter_dropdown_controller"
application.register("filter-dropdown", FilterDropdownController)

import CompensationFilterController from "./compensation_filter_controller"
application.register("compensation-filter", CompensationFilterController)

import LocationFilterController from "./location_filter_controller"
application.register("location-filter", LocationFilterController)

import LocationModeFieldsController from "./location_mode_fields_controller"
application.register("location-mode-fields", LocationModeFieldsController)

import OpenDialogController from "./open_dialog_controller"
application.register("open-dialog", OpenDialogController)

import OverflowShadowController from "./overflow_shadow_controller"
application.register("overflow-shadow", OverflowShadowController)

import AccordeonController from "./accordeon_controller"
application.register("accordeon", AccordeonController)

import RecurrenceFieldsController from "./recurrence_fields_controller"
application.register("recurrence-fields", RecurrenceFieldsController)

import SectionVisibilityController from "./section_visibility_controller"
application.register("section-visibility", SectionVisibilityController)

import SchoolAutocompleteController from "./school_autocomplete_controller"
application.register("school-autocomplete", SchoolAutocompleteController)

import CascadingSelectController from "./cascading_select_controller"
application.register("cascading-select", CascadingSelectController)

import AddressRelationsController from "./address_relations_controller"
application.register("address-relations", AddressRelationsController)

import CascadingSelectChainController from "./cascading_select_chain_controller"
application.register("cascading-select-chain", CascadingSelectChainController)

import RecipientSummaryToggleController from "./recipient_summary_toggle_controller"
application.register("recipient-summary-toggle", RecipientSummaryToggleController)

import Select2ChoiceSyncController from "./select2_choice_sync_controller"
application.register("select2-choice-sync", Select2ChoiceSyncController)

import SidenavController from "./sidenav_controller"
application.register("sidenav", SidenavController)

import MaskedValueController from "./masked_value_controller"
application.register("masked-value", MaskedValueController)

import GooglePlacesAddressController from "./google_places_address_controller"
application.register("google-places-address", GooglePlacesAddressController)

import ExpandGroupController from "./expand_group_controller"
application.register("expand-group", ExpandGroupController)

import RecordSelectionController from "./record_selection_controller"
application.register("record-selection", RecordSelectionController)

import PanelListController from "./panel_list_controller"
application.register("panel-list", PanelListController)

import PickerFieldController from "./picker_field_controller"
application.register("picker-field", PickerFieldController)

import ScheduleMeetingController from "./schedule_meeting_controller"
application.register("schedule-meeting", ScheduleMeetingController)

import AutoTriggerController from "./auto_trigger_controller"
application.register("auto-trigger", AutoTriggerController)

import DateRangeValidationController from "./date_range_validation_controller"
application.register("date-range-validation", DateRangeValidationController)

import DateRangePickerController from "./date_range_picker_controller"
application.register("date-range-picker", DateRangePickerController)

import CareerAssistantDrawerController from "./career_assistant/drawer_controller"
import CareerAssistantConversationController from "./career_assistant/conversation_controller"
import CareerPlanPreviewController from "./career_plan_preview_controller"
application.register("career-assistant-drawer", CareerAssistantDrawerController)
application.register("career-assistant-conversation", CareerAssistantConversationController)
application.register("career-plan-preview", CareerPlanPreviewController)

import UrlHandlerController from "./url_handler_controller"
application.register("url-handler", UrlHandlerController)

import FirstSubmitMarkerController from "./first_submit_marker_controller"
application.register("first-submit-marker", FirstSubmitMarkerController)

import SensitiveInputController from "./sensitive_input_controller"
application.register("sensitive-input", SensitiveInputController)

import LoadingSpinnerController from "./loading_spinner_controller"
application.register("loading-spinner", LoadingSpinnerController)

import ChipInputController from "./chip_input_controller"
application.register("chip-input", ChipInputController)

import MultiSelectDropdownController from "./multi_select_dropdown_controller"
application.register("multi-select-dropdown", MultiSelectDropdownController)

import ReportsDownloadController from "./reports_download_controller"
application.register("reports-download", ReportsDownloadController)

import StepFlowController from "./step_flow_controller"
application.register("step-flow", StepFlowController)

import SingleSubmissionController from "./single_submission_controller"
application.register("single-submission", SingleSubmissionController)

import ViewSwitcherController from "./view_switcher_controller"
application.register("view-switcher", ViewSwitcherController)

import SubmitPlaceholderController from "./submit_placeholder_controller"
application.register("submit-placeholder", SubmitPlaceholderController)

import OutsideSubmitController from "./outside_submit_controller"
application.register("outside-submit", OutsideSubmitController)

import ExtraDegreeController from "./extra_degree_controller"
application.register("extra-degree", ExtraDegreeController)

import RegistrationRecordFormController from "./registration_record_form_controller"
application.register("registration-record-form", RegistrationRecordFormController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import DocumentEditorController from "./document_editor_controller"
application.register("document-editor", DocumentEditorController)
